import { fetchCashbackReport } from "api/admin/billCashback";
import { useState } from "react";
import { downloadFile } from "utilities/download";
import { showDanger } from "utilities/misc";
import { Button, errorMessage } from "../access-control/components";
export default function ExportReport() {
  const [busy, setBusy] = useState(false);
  return (
    <Button
      variant="secondary"
      disabled={busy}
      onClick={async () => {
        setBusy(true);
        try {
          const report = await fetchCashbackReport();
          if (!report) {
            showDanger("No campaign report is available");
            return;
          }
          downloadFile(
            JSON.stringify(report, null, 2),
            "cashback-report.json",
            "application/json",
          );
        } catch (error) {
          showDanger(errorMessage(error));
        } finally {
          setBusy(false);
        }
      }}
    >
      {busy ? "Exporting…" : "Export report (JSON)"}
    </Button>
  );
}
